import React from 'react'
import '../../Styles/Home.css';

export default function Section1() {
    return (
        <div className='flex flex-col lg:flex-row items-center gap-7 lg:gap-0 w-[90%] mx-auto custom-font md:min-h-screen py-10'>
            <div className='w-[100%] lg:w-[50%]'>
                <h1 className='cryp-gradient uppercase font-Jap '>Experience Web3 Freedom – A Non-Custodial, Multi-Chain Wallet Engineered for You.</h1>
                <p className='text-[#0500FF] font-normal uppercase text-sm'>Secure, Powerful, and Built for the Future of Decentralized Finance.</p>
                <div className='font-normal text-[#2264DC] flex gap-4'>
                    <button className='px-3 py-1' style={{ border: '2px solid #2264DC', borderRadius: '50px' }}>Download for iOS <i class="fa-brands fa-apple ml-1"></i></button>
                    <button className='px-3 py-1' style={{ border: '2px solid #2264DC', borderRadius: '50px' }}>Download APK<i class="fa-brands fa-android ml-1"></i></button>
                </div>
            </div>
            <div className='w-[100%] lg:w-[50%] bounce'>
                <img src='/assets/img/sec1right.svg' className='mx-auto'></img>
            </div>
        </div>
    )
}
